import Helper from '@/utils/helper'
import { colorSchemes } from '@/app/const/settings'
import assets from '@/app/const/assets'

class ColorScheme {
  constructor ({ logo, code, executorTitle, ticketTitle, stateTitle, pageTimer, adPolicy }) {
    Helper.checkNonNegativeInt('ColorScheme.pageTimer', pageTimer)

    this.logo = Helper.getValue(logo, assets.logo)
    this.code = Helper.getValue(code, colorSchemes.default)
    this.executorTitle = Helper.getValue(executorTitle)
    this.ticketTitle = Helper.getValue(ticketTitle)
    this.stateTitle = Helper.getValue(stateTitle)
    this.pageTimer = pageTimer
    this.adPolicy = adPolicy
  }

  getCode () {
    return this.code
  }

  getLogo () {
    return this.logo
  }

  getExecutorTitle () {
      return this.executorTitle
  }

  getTicketTitle () {
      return this.ticketTitle
  }

  getStateTitle () {
      return this.stateTitle
  }

  hasExecutorTitle () {
      return Boolean(this.executorTitle)
  }

  hasTicketTitle () {
      return Boolean(this.ticketTitle)
  }

  hasStateTitle () {
      return Boolean(this.stateTitle)
  }

  getPageTimer () {
    return this.pageTimer
  }

  getAdPolicy () {
    return this.adPolicy
  }
}

export default ColorScheme
